

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface LabTestMaterialParameter extends Parameter {
    SearchTerm: number;
    OrderBy: string;
  
}

export interface LabTestMaterial {
    id?: string;
    name: string;
    isActive: string;
    parameters?: LabTestMaterialParameter[];
    links?: any;
}

export abstract class LabTestMaterialData {
  //abstract fireRequest(data: Department, method: string): Observable<any>;
  abstract list(url: string): Observable<LabTestMaterial[]>;
  abstract create(url: string,data: LabTestMaterial): Observable<any>;
  abstract update(url: string,data: LabTestMaterial): Observable<any>;
  abstract delete(url: string): Observable<any>;
}
